<ng-container *ngIf="viewMode && model">
  <dcp-search-product-grid></dcp-search-product-grid>
</ng-container>
